import CheckableTag from './CheckableTag';

export default CheckableTag;
